import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NormalReservation, Reservation, ReservationsService } from '../reservations.service';

@Component({
    selector: 'app-simple-reservations',
    templateUrl: './simple-reservations.component.html',
    styleUrls: ['./simple-reservations.component.css'],
    standalone: false
})
export class SimpleReservationsComponent implements OnInit {

  @Input() settings: NormalReservation;

  public orgId: string;
  public reservations: Reservation[] = [];

  constructor(private _reservationsService: ReservationsService, private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const routeParams = this._activatedRoute.snapshot.params;
    this.orgId = routeParams.orgId;

    this._reservationsService.getReservations(this.orgId).subscribe(result => {
      this.reservations = result;
    });

    this._reservationsService.approveReservationSubject.subscribe(index => {
      const selectedReservation = { ...this.reservations[index] };
      this._reservationsService.approveReservation(selectedReservation.reservationCode).subscribe(result => {
        this.reservations[index].status = result.status;
      });
    });
  }

  onReservationDetailsSaveClick(type: number) {
    this._reservationsService.updateReservationValue(this.orgId, type,
      (type === 1 ? this.settings.blockReservationAt : this.settings.expireReservationAt), null);
  }

}
